<template>
    <div>

        <b-button variant="danger" v-b-modal.destroyTheme>Deletar</b-button>

        <b-modal
            id="destroyTheme"
            title="Deletar Tema"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">

                <p>
                    Tem certeza que deseja deletar o tema <b>{{ theme.name }}</b> ?
                </p>

                <!-- Destroy -->
                <b-button type="button" variant="danger" :disable="loading" @click="destroy">
                    Deletar Tema
                </b-button>

            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['endpoint', 'theme'],
    data() {
        return {
            loading: false,
        }
    },
    methods: {

        destroy() {
            this.loading = true;
            axios.delete(this.endpoint)
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
